import React, {useCallback, useState} from 'react';
import LanguageForm from './LanguageForm';
import LanguageList from './LanguageList';
import {toast} from 'react-toastify';
import {COMPLETE_CURRICULUM_VITAE_LANGUAGE_TOAST_MESSAGES, getErrorUpdateToastPropsBy, getSuccesToastPropsBy} from '../../../../service/toastService';
import {createCurriculumVitaeLanguage, deleteCurriculumVitaeLanguage, updateCurriculumVitaeLanguage} from '../../../../api/curriculumVitaeApi';
import {useDispatch} from 'react-redux';
import {showModal} from '../../../../redux/system/actions';
import ConfirmModal from '../../../common/modals/ConfirmModal';

const CONFIRM_MODAL_ID = 'confirmModal';

function Language({curriculumVitae, setCurriculumVitae}) {
    const dispatch = useDispatch();
    const handleShowModal = useCallback((modalId) => dispatch(showModal(modalId)), [dispatch]);

    const [languages, setLanguages] = useState(curriculumVitae.curriculumVitaeLanguages);
    const [editingLanguage, setEditingLanguage] = useState(null);
    const [languageToDelete, setLanguageToDelete] = useState(null);

    const handleSaveLanguage = async (languageData) => {
        try {
            if (editingLanguage) {
                const updatedLanguage = await updateCurriculumVitaeLanguage(languageData);
                const updatedLanguages = languages.map((language) =>
                    language.id === languageData.id ? updatedLanguage.data : language
                );

                setLanguages(updatedLanguages);
                setCurriculumVitae((prevCv) => ({
                    ...prevCv,
                    curriculumVitaeLanguages: updatedLanguages,
                }));

                toast.success('Language updated successfully!', getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_LANGUAGE_TOAST_MESSAGES));
            } else {
                const newLanguage = await createCurriculumVitaeLanguage(languageData);
                const updatedLanguages = [...languages, newLanguage.data];

                setLanguages(updatedLanguages);
                setCurriculumVitae((prevCv) => ({
                    ...prevCv,
                    curriculumVitaeLanguages: updatedLanguages,
                }))

                toast.success('Language added successfully!', getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_LANGUAGE_TOAST_MESSAGES));
            }

            setEditingLanguage(null);
        } catch (error) {
            toast.error('Something went wrong! Please try again.', getErrorUpdateToastPropsBy(COMPLETE_CURRICULUM_VITAE_LANGUAGE_TOAST_MESSAGES));
        }
    };

    const handleDeleteLanguage = async () => {
        if (!languageToDelete) return;
        try {
            await deleteCurriculumVitaeLanguage(languageToDelete);
            setLanguages((prevLanguages) => prevLanguages.filter((exp) => exp.id !== languageToDelete));
            setCurriculumVitae((prevCv) => {
                const updatedLanguages = prevCv.curriculumVitaeLanguages.filter((exp) => exp.id !== languageToDelete);
                return {
                    ...prevCv,
                    curriculumVitaeLanguages: updatedLanguages,
                };
            });
            toast.success('Language deleted successfully!', getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_LANGUAGE_TOAST_MESSAGES));
            setLanguageToDelete(null);
        } catch (error) {
            toast.error('Something went wrong! Please try again.');
        }
    };

    const handleEditLanguage = (language) => {
        setEditingLanguage(language);
    };

    const confirmDeleteLanguage = (languageId) => {
        setLanguageToDelete(languageId);
        handleShowModal(CONFIRM_MODAL_ID);
    };

    return (
        <div>
            <h4 className="mb-4" style={{textDecoration: 'underline', textUnderlineOffset: '7px'}}>
                Languages
            </h4>

            <LanguageForm curriculumVitaeId={curriculumVitae.id} initialLanguage={editingLanguage} setEditingLanguage={setEditingLanguage}
                onSave={handleSaveLanguage}/>

            <LanguageList languages={languages} onEdit={handleEditLanguage} onDelete={confirmDeleteLanguage}/>

            <ConfirmModal
                id={CONFIRM_MODAL_ID}
                title="Are you sure you want to delete this language?"
                message="This will permanently remove the selected language from your profile. Do you wish to proceed?"
                onConfirm={handleDeleteLanguage}
            />
        </div>
    );
}

export default Language;
